/**
 * Single source of truth for the platform legal documents (EULA / Terms &
 * Conditions / Privacy Policy) and the consent version users accept via the
 * analytics consent banner.
 *
 * When the documents change, do all three in lock-step:
 *   1. Upload the new PDF to S3 (update LEGAL_DOCS_LINK if the object key changes).
 *   2. Bump CONSENT_VERSION so the banner re-triggers for users on an older version.
 *   3. Update the `has-consented` flag in PostHog so its release condition matches
 *      `consent_version >= CONSENT_VERSION` — otherwise remote consent sync will
 *      keep suppressing the refreshed banner for previously-consented users.
 *   4. Update `analytics.banner.content` (and `title` if needed) to describe what
 *      changed in this version. The banner only ever shows the current version's
 *      copy, so a stale message ships unless it's rewritten alongside the bump.
 *
 * Local records written before versioning stored the string 'true'; those are
 * migrated to version 1 (see getAcceptedConsentVersion in plugins/post-hog.ts).
 */
export const LEGAL_DOCS_LINK =
  'https://boq-public-images.s3.af-south-1.amazonaws.com/Documents/Budgetcontrol+Terms+%26+Conditions+20-07-26.pdf';

export const CONSENT_VERSION = 2;
